const getSeparator = (url: string) => {
  if (!url.includes('?')) {
    return '?';
  }
  if (url.endsWith('?') || url.endsWith('&')) {
    return '';
  }

  return '&';
};

// This function would usually be written using the native URL API.
// However, this code is expected to be run within an Open Component and this URL API is NOT available in that environemnt.
// This is why we are having to create a custom function to do this
// When this restriction is lifted, it should be migrated to use the native URL API
const addOrModifyQueryParam = (url: string, key: string, value?: string) => {
  if (!value) return url;

  // Check if the key already exists in the query string
  const regex = new RegExp(`([?&])${key}=[^&]*`);
  if (regex.test(url)) {
    // If key exists, replace the existing value
    return url.replace(regex, `$1${key}=${value}`);
  }

  // Only guess separator if we're adding a new key-value pair
  const guessedSeparator = getSeparator(url);

  // If key does not exist, append it
  return `${url}${guessedSeparator}${key}=${value}`;
};

// This function would usually be written using the native URL API.
// However, this code is expected to be run within an Open Component and this URL API is NOT available in that environemnt.
// This is why we are having to create a custom function to do this
// When this restriction is lifted, it should be migrated to use the native URL API
const deleteQueryParam = (url: string, key: string) => {
  const [address, search] = url.split('?');

  if (!search) {
    return address;
  }

  const params = search.split('&').map((param) => param.split('='));
  const deletedParamIndex = params.findIndex((param) => param[0] === key);

  if (deletedParamIndex === -1) {
    return url;
  }

  params.splice(deletedParamIndex, 1);

  if (params.length === 0) {
    return address;
  }

  return [address, params.map((param) => param.join('=')).join('&')].join('?');
};

const appendCultureToUrl = (url: string, locale: string, market: string) => {
  const urlWithMarket = addOrModifyQueryParam(url, 'market', market);
  return addOrModifyQueryParam(urlWithMarket, 'locale', locale);
};

export { getSeparator, addOrModifyQueryParam, appendCultureToUrl, deleteQueryParam };
